import {
  IConfiguration,
  ICustomer,
  IEquipmentTypes,
  ILead,
  INextArticle,
  INextArticles,
  IOrder,
  IPcodes,
  IPimSnapshot,
  IUniqueModelCodeAndSkus,
  IUserInput,
  IVatCalculation,
  IVehicleConfiguration,
  IVehicleEquipment,
  IVehicleOption,
  IVehicleRemoveAccessory,
  OrderSource,
} from 'next-common';
import {
  IExtendedCacheVehicleStock,
  IPcodeMaster,
  VehicleStockStatus,
  VehicleCondition,
  IModelSeriesMapping,
} from 'sales-types-common';
import { IRuleValues } from '../../components/common-components/RulesPopup/RulesDetail';
import { PageSteps } from '../../components/sales/sales-common/NewHeader';
import { IPcodeValidation } from '../../components/sales/sales-wizard';
import { IStepMenuData } from '../../components/sales/sales-wizard/sales-wizard-menu';
import { ISalesPackageOptionValue, IVehicleChargeStatus } from './vehicle';
import { ICartPricesExtended } from '../../utils';
import { CartImageData, ReserveButtonStages, TMessageBarSeverity } from 'types';

export interface IVehiclePageProps extends ICentralisedProperties {
  orderId: string;
  pimId?: string;
  pimCode?: string;
  reserveButtonStage?: ReserveButtonStages;
  isLoading?: boolean;
  isReserveLoading?: boolean;
  isFactoryOrder?: boolean;
  isVehicleSelected?: boolean;
  vehicleLocation?: string;
  vehicleStatus?: string;
  isSelectedVehicleUnavailable?: boolean;
  isUnavailablePimData?: boolean;
  expectedProductionDate?: Date;
  articles?: INextArticle[];
  finalPrice?: ICartPricesExtended;
  vehicleId?: string;
  source?: OrderSource;
  currentStep?: PageSteps;
  serialNo?: string;
  make?: string;
  onReserveOrCancelOrder?(): void;
  calculationId?: string;
  activeStep?: number;
  menuLoading?: boolean;
  isVehicleValidForReserveOrSign?: boolean;
  vehicleAvailabilityCode?: string;
  onClickSigning?(stepData?: IStepMenuData): void;
  onClick?(stepData?: IStepMenuData): void;
  selectedVariantPath?: string;
  vehicleChargeStatus?: IVehicleChargeStatus;
  isVarebilEnabled?: boolean;
  pCodeMasterData?: IPcodeMaster[];
  disablePCodePage?: boolean;
  setDisablePCodePage?(value: boolean): void;
  allStepData?: IStepMenuData[];
  invalidPcodesValidation?: IPcodeValidation;
  isTradeInClicked?: boolean;
  toggleTradeIn?(value: boolean): void;
  isUsedCar?: boolean;
  isUsedImportCar?: boolean;
  orderType?: string;
  isMerBrand?: boolean;
  isOldConfig?: boolean;
  order?: IOrder;
  isForeignBrand?: boolean;
}

export interface INotificationPageProps {
  clearNotifications?(key?: string): void;
}

export interface IVehicleStock extends IExtendedCacheVehicleStock {
  isDisable?: boolean;
}

interface IOrderReference {
  pimId?: string;
  pimCode?: string;
}
interface IInputInterface {
  customer?: ICustomer;
  isAgent?: boolean;
  orderReference?: IOrderReference;
  soldByDealerId?: string;
  discount: number;
  user: Partial<IUserInput>;
  vatCalculation?: IVatCalculation;
  lead?: ILead;
  chargesAreOverridden?: boolean;
  pimSnapshot?: IPimSnapshot;
}
export interface IVehicleListOrderProps {
  id: string;
  input: IInputInterface;
  options?: IVehicleOption[];
  vehicles?: IVehicleConfiguration[];
  vatCalculation?: IVatCalculation;
  nextArticles?: INextArticles;
  removeAccessories?: IVehicleRemoveAccessory[];
  removePcodes?: IPcodes[];
}

export interface IVehicleChanged {
  isVehicleChange?: boolean;
  vehicleConfig?: IVehicleConfiguration;
}

export interface IVarnishData {
  colorId: string;
  color: string;
  colorPrice: number;
  colorValidFrom: string;
  colorValidTo: string;
  colorName: string;
}

export interface IInteriorData {
  interiorCode: string;
  interiorPrice: number;
  interiorValidFrom: string;
  interiorValidTo: string;
  interiorId: string;
  interiorName: string;
}
export interface IOptionMetaData {
  interiorCode?: string;
}

export interface IValidationToastNotification {
  onClose?(): void;
  severityLevel?: TMessageBarSeverity;
}

export interface ICentralisedProperties {
  configuration?: IConfiguration;
}

export interface IVehicleFilter {
  colorId: IVehicleFilterDetail[];
  modelId: IVehicleFilterDetail[];
  allModelCodes: IVehicleFilterDetail[];
  exteriorSelectableFormatter: IVehicleFilterDetail[];
  trackTraceCode: ITrackTraceCode[];
  interiorCode: IVehicleFilterDetail[];
  locationId: IVehicleFilterDetail[];
}
export interface IVehicleFilterDetail {
  value: string;
  name?: string;
}

export interface ITrackTraceCode {
  value: string;
}

export interface IStockFilterOptions {
  label: string;
  value: string;
  isDisabled?: boolean;
}

export interface IRangeFilter {
  from: string | number;
  to: string | number;
}

export interface IStockFilterConfig {
  brands?: IStockFilterOptions[];
  modelIds?: IStockFilterOptions[];
  colorIds?: IStockFilterOptions[];
  interiorIds?: IStockFilterOptions[];
  optionIdsIncluded?: IStockFilterOptions[];
  applicationCodeList?: IStockFilterOptions[];
  vehicleCondition?: IStockFilterOptions[];
  locationIds?: IStockFilterOptions[];
  modelSeries?: IStockFilterOptions[];
  searchText?: string;
  productionDate?: IRangeFilter;
  ttCode?: IRangeFilter;
  price?: IRangeFilter;
  availabilityCodes?: IStockFilterOptions[];
  status?: string[];
}

export interface IRulesPopup extends IRulesTableCommon {
  isOpen: boolean;
  loading?: boolean;
  handleClose?: () => void;
  handleConfirm?: () => void;
}

export interface IRulesTable extends IRulesTableCommon {}

export interface IRulesTableCommon {
  ruleAddVaules: IRuleValues[];
  ruleRemoveVaules: IRuleValues[];
  popupPrice: number;
  selectableName: string;
  ruleDefaultValues?: IRuleValues[];
}
export interface ITilleggSelectable {
  sku?: string;
  optionId?: string;
  isSelected?: boolean;
  isUnavailable?: boolean;
  name?: string;
}

export interface IVehicleListItems {
  id?: number;
  farge?: string;
  interiorCode?: string;
  colorId?: string;
  selectedEquipment?: string;
  serialno?: number;
  serialNumber?: number;
  prod?: string;
  tt?: number;
  statusName?: string;
  status?: string;
  price?: string;
  vinNumber?: string;
  oemOrderNo?: string;
  applicationCode?: string;
  locationId?: string;
  disabled?: boolean;
  priceOptions?: string;
  optionCode?: string;
  unAvailableSkus?: string[];
  interior?: ISalesPackageOptionValue[];
  rims?: ISalesPackageOptionValue[];
  varnish?: ISalesPackageOptionValue[];
  interiorSelectable?: ISalesPackageOptionValue[];
  exteriorSelectable?: ISalesPackageOptionValue[];
  listverkSelectable?: ISalesPackageOptionValue[];
  taklakkSelectable?: ISalesPackageOptionValue[];
  packageSku?: string;
  interiorSelectableFormatter?: ITilleggSelectable[];
  exteriorSelectableFormatter?: ITilleggSelectable[];
  listverkSelectableFormatter?: ITilleggSelectable[];
  taklakkSelectableFormatter?: ITilleggSelectable[];
  salesPackageFormatter?: ITilleggSelectable[];
  selectedRims?: IEquipmentTypes;
  image?: CartImageData;
  fargeFormatter?: ITilleggSelectable[];
  felgerFormatter?: ITilleggSelectable[];
  interiorFormatter?: ITilleggSelectable[];
  fomattedFarge?: ITilleggSelectable;
  formattedInterior?: ITilleggSelectable;
}

export interface Dealer {
  dealerName?: string;
  dealerId?: string;
}

export interface FilterCount {
  code: string;
  count: number;
  value?: string;
}

export type FilterCounts<T extends string> = {
  [K in T]?: FilterCount[];
};

export type VehicleFilterKey =
  | 'brand'
  | 'modelSeries'
  | 'modelId'
  | 'pimSku'
  | 'colorCode'
  | 'interiorCode'
  | 'options';

export type VehicleFilterType = VehicleFilterKey | 'locationId' | 'exactMatchCode';

export type IVehicleFiltersWithCounts = FilterCounts<
  'modelId' | 'pimSku' | 'colorCode' | 'interiorCode' | 'exactMatchCode' | 'locationId'
>;

export type IVehicleSelectedFilters = Record<VehicleFilterKey, string> & {
  dataFromFactoryEquipLevels?: IUniqueModelCodeAndSkus | null;
};

export type IVehicleCountsPayload = {
  vehicleCondition: VehicleCondition[];
  applicationCode: string[];
  hiddenInNext: boolean;
  status: VehicleStockStatus[];
  filterTypes: VehicleFilterType[];
} & {
  [K in VehicleFilterKey]: string[];
};

export enum FILTER_FETCH_STEP {
  MODEL_VARIANT = 'modelVariant',
  ALL_FILTERS = 'allFilters',
}

type FilterFetchStep = FILTER_FETCH_STEP.MODEL_VARIANT | FILTER_FETCH_STEP.ALL_FILTERS;

export interface FilterFetchStrategy {
  shouldFetch: () => { step: FilterFetchStep } | null;
  buildPayload: (step: FilterFetchStep) => any;
  getExactMatchOverrides?(): { modelId: string; skus: string[] } | null;
}

export interface FilterFetchStrategyParams {
  selectVehicleFilters: IVehicleSelectedFilters;
  applicationCodes: string[];
  order: IOrder | null;
  modelSeriesMappingData: IModelSeriesMapping[] | null;
  selectedEquipmentIds?: IVehicleEquipment[] | IEquipmentTypes[] | null;
  dataFromFactoryEquipLevels?: IUniqueModelCodeAndSkus | null;
  hasFetchedModelVariantCounts?: boolean;
}

export interface IVehicleCountBySeller {
  own: {
    own: number;
    locationIds: IStockFilterOptions[];
  };
  port: {
    importer: number;
    locationIds: IStockFilterOptions[];
  };
  other: {
    dealer?: number;
    locationIds: IStockFilterOptions[];
  };
}
